import { render, staticRenderFns } from "./OrderKanbanColumn.vue?vue&type=template&id=2a513f45&scoped=true&"
import script from "./OrderKanbanColumn.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "~/components/orderKanban/OrderKanbanColumn.scss?vue&type=style&index=0&id=2a513f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a513f45",
  null
  
)

export default component.exports